import { render, staticRenderFns } from "./suifangshuju.vue?vue&type=template&id=2d4e508b&"
import script from "./suifangshuju.vue?vue&type=script&lang=ts&"
export * from "./suifangshuju.vue?vue&type=script&lang=ts&"
import style0 from "./suifangshuju.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports